// Tell webpack to include your component specific css
require("./teaserContent.css");
var SPScript = require("spscript");
var lists = require("../../shared/lists");

// Pull in template as a string by using html-loader(html!)

// if there is no 'teaserUrl' querystring param, show nothing
// if there is a queryString param, query list to find teaser content
// if there is no match, show default teaser content
var templating = require("spscript").templating;
var normalizeUrl = function(url) {
	return encodeURI(decodeURI(url.toLowerCase()));
};

var defaultItem = {
	TeaserContent: "<H2>Create an account</H2>"
};
var create = function(containerSelector) {
	var component = {};
	component.container = document.querySelector(containerSelector);
	var qs = SPScript.queryString.toObj(window.location.search);

	component.init = function() {
		if (qs.teaserUrl) {
			component.teaserUrl = normalizeUrl(qs.teaserUrl);
			component.getTeaserContent().then(component.render);
		}
	};

	component.getTeaserContent = function() {
		return lists.TeaserContent
			.getItems("$select=TeaserUrl,TeaserContent")
			.then(items => {
				var specificItemTeaser = items.filter(i => normalizeUrl(i.TeaserUrl) === normalizeUrl(component.teaserUrl)); // find a url match
				var defaultItemTeaser = items.filter(i => i.TeaserUrl === "default"); // find the default item from list

				return (specificItemTeaser.length && specificItemTeaser[0]) 
					|| (defaultItemTeaser.length && defaultItemTeaser[0]) 
					|| defaultItem; // use hardcoded default item
			});;
	};

	component.render = function(item) {
		if (component.container && item.TeaserContent) {
			component.container.innerHTML = item.TeaserContent;
		} 
	}

	component.init();
	return component;
};

module.exports = { create: create };



// WEBPACK FOOTER //
// ./src/scripts/components/teaserContent/index.js